import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    partiesStats: []
};

export const partiesStatsSlice = createSlice({
    name: 'partiesStatsSlice',
    initialState,
    reducers: {
       
        getPartiesStats: (state, action) => {
            state.partiesStats = action.payload;
        }
    },
});

// Action creators are generated for each case reducer function
export const { getPartiesStats} = partiesStatsSlice.actions;

export default partiesStatsSlice.reducer;
